import React from 'react';

export const ResetSuccess = () =>
  <div className="mb-0 mt-4 alert alert-success alert-dismissible fade show" role="alert">
    <button type="button" className="close" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
    <i className="material-icons alert-icon" aria-hidden="true">check</i>
    Your request has been submitted. An email has been sent to your email inbox for password reset details.
  </div>;

export const ResetGenericFailed = () =>
  <div className="mb-0 mt-4 alert alert-danger alert-dismissible fade show" role="alert">
    <p className="text-dark d-block w-100 text-center">An error has occurred, and your password could not be reset.
    Please try again, and contact your administrator if the issue persists.
    </p>
  </div>;
